var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiebherrPaintingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 20.5L21.5 20.9L19.8 23.2L20.7 24.7L24 24.1L26 21.8M34.4 9.4L25 18.7C22.9 20.8 24.6 23.3 27 21.5C29.6 19.6 37.2 13.8 37.2 13.8M37.3 13.8L49.9 24.9M49.9 25C44.5 28.8 41.5 34.1 39.7 37.6M56.2 28.1C53.8 34.2 51.8 38.3 46.7 43.1M34.2 43.9C29.9 46.3 27.2 50.8 27.1 55.7H53.9C54 50.7 51.3 46.1 46.8 43.9M53.1 16.8L38.7 9.4",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1 28.1C58.3585 28.1 61 25.4585 61 22.2C61 18.9415 58.3585 16.3 55.1 16.3C51.8415 16.3 49.2 18.9415 49.2 22.2C49.2 25.4585 51.8415 28.1 55.1 28.1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 50.2C43.9794 50.2 46.8 47.3794 46.8 43.9C46.8 40.4206 43.9794 37.6 40.5 37.6C37.0206 37.6 34.2 40.4206 34.2 43.9C34.2 47.3794 37.0206 50.2 40.5 50.2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 13.9C38 13.9 39.3 12.7 39.3 11.2C39.3 11.2 39.3 11.2 39.3 11.1C39.3 9.6 38.1 8.3 36.5 8.3C34.9 8.3 33.7 9.5 33.7 11.1C33.8 12.7 35 13.9 36.5 13.9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25.6L18.3 22.8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 33.3L19.1 24.8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 39.2L20.6 26.3",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiebherrPaintingIcon);
export default __webpack_public_path__ + "static/media/liebherr-painting-icon.babd930ac6f4c56e6c9c66c9b83ec999.svg";
export { ForwardRef as ReactComponent };